module.exports = new __parcel__URL__("627fbb5a-3bae-4cd9-b617-2f923e29d55e.302150d2.woff2").toString();